
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum",
      function () {
        return require("private-next-pages/curriculum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum"])
      });
    }
  